export default __webpack_public_path__ + "media/images/icons/calendar-alt-solid-65773e7683b2d8ebd653ba0f28193c29.svg";